import { useContext, useEffect, useState } from 'react';
import UtilController from '../../../controller/UtilController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import styled from 'styled-components';
import { CurrentStoreContext } from '../../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import CheckoutController from '../../../controller/CheckoutController';

const HotelRoomSetting = () => {
  const showToast = useToast();
  const { userInfo } = useContext(AuthContext);
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [storeName, setStoreName] = useState<string>('');
  const [storeNameEn, setStoreNameEn] = useState<string>('');
  const [logoImage, setLogoImage] = useState<string | null>(null);
  const [logoMediaId, setLogoMediaId] = useState<number | null>(null);

  // storeName
  const onChange_storeName = (event: any) => {
    setStoreName(event.target.value);
  };
  const onChange_storeNameEn = (event: any) => {
    setStoreNameEn(event.target.value);
  };

  // 필수 확인
  const checkRequired = () => {
    if (storeName && storeName.length > 1 && storeNameEn && storeNameEn.length > 1) return true;
    return false;
  };

  // 이미지 등록
  const uploadLogoImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.extendStoreUploadImg(formData, userInfo.user_id);
          console.log('extendStoreUploadImg', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              setLogoImage(oResponse.data.url_path);
              setLogoMediaId(oResponse.data.store_media_id);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    }
  };

  // 이미지 삭제
  const deleteLogoImage = () => {
    setLogoImage(null);
    setLogoMediaId(null);
  };

  // 데이터 호출
  const getCheckoutRepresentStoreNameAndImage = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };

      const oRes = await CheckoutController.getCheckoutRepresentStoreNameAndImage(oParams);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCheckoutRepresentStoreNameAndImage', oResponse);
        if (oResponse.data && oResponse.ok) {
          const oData = oResponse.data.data;
          setStoreName(oData.store_name);
          setStoreNameEn(oData.store_name_en);
          setLogoImage(oData.logo_store_url);
          setLogoMediaId(oData.store_media_id);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  // 저장
  const setCheckoutRepresentStoreNameAndImage = async () => {
    try {
      if (checkRequired()) {
        const oParams = {
          store_id: currentStore.value,
          store_name: storeName,
          store_name_en: storeNameEn,
          store_media_id: logoMediaId,
        };

        const oRes = await CheckoutController.setCheckoutRepresentStoreNameAndImage(oParams);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log('setCheckoutRepresentStoreNameAndImage', oResponse);
          if (oResponse.data && oResponse.ok) {
            showToast('매장 정보를 수정했어요');
          }
        }
      } else {
        showToast('필수 항목을 추가해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getCheckoutRepresentStoreNameAndImage();
  }, [currentStore]);

  return (
    <Style>
      <div className="contentContainer">
        <div className="inputText">
          <div className="storeName">
            <h4>퇴실/연장 상시판매 매장명</h4>
            <h5>(미 설정 시 직영 매장에서 안 보일 수 있습니다.)</h5>
          </div>
          <input
            id="storeName"
            type="text"
            placeholder="매잠명을 입력해주세요  예) 노크노크 연장 상품"
            value={storeName}
            onChange={onChange_storeName}
            autoFocus={true}
          />
        </div>
        <div className="inputText">
          <div className="storeName">
            <h4>퇴실/연장 상시판매 매장 영문명</h4>
            <h5>(미 설정 시 직영 매장에서 안 보일 수 있습니다.)</h5>
          </div>
          <input
            id="storeNameEn"
            type="text"
            placeholder="매장명을 입력해주세요  예) Knock Knock check-out"
            value={storeNameEn}
            onChange={onChange_storeNameEn}
          />
        </div>
        <div className="inputText">
          <div className="storeName">
            <h4>이미지</h4>
            <h5 className="grayFont">권장사이즈: 800 x 680</h5>
          </div>
          <div className="imageList logo">
            <input
              id="logoImage"
              type="file"
              name="photo"
              accept="image/*"
              autoFocus={false}
              onChange={uploadLogoImage}
            />
            {logoImage && logoImage !== '' ? (
              <div className="previewImageWrap">
                <img className="previewImg" src={logoImage} alt="img" />
              </div>
            ) : (
              <label className="photoBox" htmlFor="logoImage">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                <h5>이미지 추가</h5>
              </label>
            )}
            {logoImage && logoImage && (
              <>
                <label className="imageButton edit" htmlFor="logoImage">
                  수정
                </label>
                <button className="imageButton delete" onClick={deleteLogoImage}>
                  삭제
                </button>
              </>
            )}
          </div>
        </div>
        <button
          onClick={setCheckoutRepresentStoreNameAndImage}
          className={`submitButton ${!checkRequired() && 'inactive'}`}>
          저장하기
        </button>
      </div>
    </Style>
  );
};

export default HotelRoomSetting;

const Style = styled.div`
  .inputText {
    img {
      cursor: pointer;
    }

    /* storeName */
    .storeName {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      gap: 4px;
      color: #555;

      h5 {
        font-size: 14px;
        font-weight: 500;
        color: #40977f;
      }
      h5.grayFont {
        font-weight: 400;
        color: #979797;
      }
    }
  }

  input {
    width: 100%;
    padding: 8px 22px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }

  .imageButton {
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 6px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
  }
  .imageButton.edit {
    border: 1px solid #cecece;
    color: #555555;
  }
  .imageButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    flex-wrap: wrap;

    .previewImageWrap {
      width: 140px;
      height: 120px;
      position: relative;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }

    .photoBox {
      position: relative;
      width: 140px;
      height: 120px;
      border-radius: 5px;
      padding: 10px;
      padding-top: 20px;
      border: 1px solid #cecece;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      cursor: pointer;

      h5 {
        color: #a7a7a7;
        font-weight: 400;
      }
    }
  }
  .imageList.logo {
    align-items: flex-end;
  }

  input[type='file'] {
    display: none;
  }

  .submitButton {
    margin-top: 30px;
  }

  @media (max-width: 600px) {
    input {
      padding: 8px 14px;
      font-size: 14px;
    }
    .storeName {
      flex-direction: column;
      align-items: flex-start !important;
    }
  }
`;
